import { Business } from 'constant';
import { Layout, LayoutProps } from 'containers';
import { getLockStatus } from 'containers/Layout/thunk';
import { useAppDispatch, useQueryParams } from 'hooks';
import { dayjs } from 'libs';
import { routes } from 'navigations/routers';
import WorkerInfo from 'pages/Home/Bo/WorkerInfo';
import WorkStatus from 'pages/SiteDetail/WorkStatus';
import { userData } from 'pages/Login/selectors';
import { FC, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { generatePath, useHistory, useParams } from 'react-router-dom';
// import { getShopWorkersChargeSiteList } from '../thunk';
import { businessDetailSelector } from './selectors';

import SectionStyled from './styles';
// 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
import {
  /// getShopSchedulesWorkersChargeSiteList,
  getSiteGroupsWorkers,
  // getSiteUserSchedules,
} from './thunk';
// 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
type Props = {};

const BusinessDetail: FC<Props> = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();
  // 2025/02/12 FJ 3月分反映分 NO58
  const { user_id, roleUser } = useSelector(userData);
  const { entity = Business.WORKER_INFO } = useParams<{ entity: Business }>();
  const { workRisk, siteGroupsWorkers } = useSelector(businessDetailSelector);
  const { buildingId } = useParams<{ buildingId: string }>();
  // 2025/02/28 Leading Win start
  const { gyosya_code } = useParams<{ gyosya_code: string }>();
  const { gyosya_siten_code } = useParams<{ gyosya_siten_code: string }>();
  // 2025/02/28 Leading Win end
  // 2025/03/13 Leading Win start
  const { first_gyosya_code } = useParams<{ first_gyosya_code: string }>();
  const { first_gyosya_siten_code } = useParams<{ first_gyosya_siten_code: string }>();
  // 2025/03/13 Leading Win end
  const currentDate = useQueryParams().get('currentDate');

  const getStatusForBuildingDetail = useCallback(
    (params: {
      building_id?: string | number;
      site_id?: string;
      date?: Date | string;
      cooperator_id?: string;
    }) => {
      dispatch(getLockStatus(params));

      // dispatch(getKYDataApproveBySiteManage(params));

      // dispatch(getStatusKy(params));
    },
    [dispatch]
  );

  const fetchAPI = useCallback(() => {
    switch (entity) {
      case Business.WORKER_INFO:
        // dispatch(getShopWorkersChargeSiteList({ building_id: +buildingId }));
        getStatusForBuildingDetail({
          building_id: buildingId,
          date: currentDate || dayjs().toDate(),
        });
        // 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
        // dispatch(
        //   getShopSchedulesWorkersChargeSiteList({
        //     building_id: +buildingId,
        //     date: dayjs().format('YYYY-MM-DD'),
        //   })
        // );
        // dispatch(getSiteUserSchedules({ building_id: +buildingId }));
        // 2025/02/12 FJ 3月分反映分 NO58 start
        dispatch(
          getSiteGroupsWorkers({
            building_id: buildingId,
            user_id: `${user_id}`,
            role: Number(roleUser),
          })
        );
        // 2025/02/12 FJ 3月分反映分 NO58 end
        // 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
        return;
      case Business.WORK_STATUS:
        return;

      default:
        return null;
    }
    // 2025/02/12 FJ 3月分反映分 NO58 start
  }, [entity, getStatusForBuildingDetail, buildingId, currentDate, dispatch, roleUser]);
  // 2025/02/12 FJ 3月分反映分 NO58 end

  useEffect(() => {
    (async () => {
      await fetchAPI();
    })();
  }, [buildingId, currentDate, fetchAPI]);

  return (
    <SectionStyled>
      <Layout
        tabs={tabs}
        defaultValue={entity}
        showNotification={true}
        onSelected={(value) =>
          history.replace(
            generatePath(routes.BusinessDetail.path, {
              buildingId,
              // 2025/02/28 Leading Win start
              gyosya_code: gyosya_code,
              gyosya_siten_code: gyosya_siten_code,
              // 2025/02/28 Leading Win end
              // 2025/03/13 Leading Win start
              first_gyosya_code: first_gyosya_code,
              first_gyosya_siten_code: first_gyosya_siten_code,
              // 2025/03/13 Leading Win end
              entity: value,
            })
          )
        }
        left
        back
        right
      />
      {entity === Business.WORK_STATUS && (
        <WorkStatus
          dataWorkRisk={workRisk.sites}
          loadingWorkRisk={workRisk.loading}
          getStatusForBuildingDetail={getStatusForBuildingDetail}
        />
      )}
      {entity === Business.WORKER_INFO && (
        // 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 start
        <WorkerInfo
          data={siteGroupsWorkers.users || []}
          //site_user_schedules={siteUserSchedules?.users || null}
        />
        // 2023/12/29 Leading Win 教育機能対応 DXWEBWIN00100_作業員情報 end
      )}
    </SectionStyled>
  );
};

const tabs: LayoutProps['tabs'] = [
  // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 start
  // { label: '作業状況', key: Business.WORK_STATUS },
  { label: '作業日報', key: Business.WORK_STATUS },
  // 2023/12/18 Leading Win 教育機能対応 DXWEBDOS00100_作業日報 end
  { label: '作業員情報', key: Business.WORKER_INFO },
];

export default BusinessDetail;
